export const defaultDateError = 'Data inválida';
export const limitTimeExceededError =
  'O horário limite expirado. Selecione o próximo dia útil ou outra data disponível.';
